(ns bp-clients.tv-app.common.components.player-fatal-error
  (:require ["react" :refer [createRef]]
            [bp-clients.tv-app.utils.utils :as utils]
            [bp-libs.design-system.components.error-instruction :refer [error-detail]]
            [bp-libs.design-system.components.menu :refer [side-menu]]
            [reagent.core :as reagent]
            [reagent.ratom :as r]))

(defn- on-unfocus
  "This listener exists to prevent lose focus when:
  - navigating up from first element
  - navigating down from last element

  https://github.com/luke-chang/js-spatial-navigation?tab=readme-ov-file#events"
  [tab-index ^js/Event e]
  (let [next-element (some-> e .-detail .-nextElement)]
    (when (and next-element
               (not= (-> next-element (.getAttribute "tabindex")) (str tab-index)))
      (utils/stop-event-propagation e))))

(defn player-fatal-error [{:keys [group-items
                                  initial-selected-group initial-selected-option]}
                          tab-index]
  (let [selected-group    (r/atom initial-selected-group)
        selected-option   (r/atom initial-selected-option)
        params            {:action-groups group-items :tab-index tab-index}
        error-detail-data (r/atom (get-in group-items [@selected-group :menu-items @selected-option :details]))
        on-item-click     (fn [group-key item-key _event]
                            (reset! selected-group group-key)
                            (reset! selected-option item-key)

                            (reset! error-detail-data
                                    (get-in group-items [@selected-group :menu-items @selected-option :details])))
        params            (assoc params :on-item-click on-item-click)
        react-ref         (createRef)
        on-unfocus-fn     (partial on-unfocus tab-index)]

    (reagent/create-class
     {:component-did-mount (fn [_]
                             (when-let [ref (.-current react-ref)]
                               (.addEventListener ref "sn:willunfocus" on-unfocus-fn))
                             (when-let [first-item (js/document.querySelector (str "*[tabindex=\"" tab-index "\"]"))]
                               (.click first-item)
                               (.focus first-item)))
      :component-will-unmount (fn [_]
                                (when-let [ref (.-current react-ref)]
                                  (.removeEventListener ref "sn:willunfocus" on-unfocus-fn)))
      :reagent-render (fn [_]
                        [:div {:class ["h-screen w-full"
                                       "z-50"
                                       "bg-surface-primary-3"
                                       "absolute"]
                               :ref react-ref}
                         [:div {:class ["flex h-screen w-full"]}
                          [error-detail @error-detail-data]
                          [side-menu params]]])})))
